import { render, staticRenderFns } from "./widget-modal-create.vue?vue&type=template&id=6b26c0ff&"
import script from "./widget-modal-create.vue?vue&type=script&lang=js&"
export * from "./widget-modal-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports